<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <card>
            <v-spacer/>

            <v-dialog
              v-model="dialog"
              persistent
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <base-button
                      :color="color"
                      class="mb-2"
                      v-on="on">
                      {{ $t("dashboard.newTag") }}
                    </base-button>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <base-input
                      v-model="search"
                      :loading="loading"
                      label="Search"
                      placeholder="Search..."
                      hide-details
                      @keyup.enter="index"/>
                  </v-flex>
                </v-layout>
              </template>
              <card>
                <v-container grid-list-md >
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm2
                      md2>
                      <base-input
                        v-model="editedItem.id"
                        :disabled="true"
                        required
                        label="Tag Id"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm5
                      md5>
                      <base-input
                        v-model="editedItem.name"
                        :label= "$t('dashboard.name')"
                        required/>
                    </v-flex>
                    <v-flex
                      xs12
                      sm5
                      md5>
                      <base-input
                        v-model="editedItem.slug"
                        required
                        label="Tag Slug" />
                    </v-flex>
                    <v-flex
                      xs12
                      sm5
                      md5>
                      <base-input
                        v-model="editedItem.count"
                        :label= "$t('dashboard.count')"
                        required
                        type="number" />
                    </v-flex>
                    <!--                    </v-flex>-->
                    <!--                    <v-flex-->
                    <!--                        xs12-->
                    <!--                        sm12-->
                    <!--                        md12>-->
                    <!--                      <base-input-->
                    <!--                          required-->
                    <!--                          v-model="editedItem.link"-->
                    <!--                          label="Link" >-->
                    <!--                      </base-input>-->
                    <!--                    </v-flex>-->
                    <!--                    <v-flex-->
                    <!--                        xs12-->
                    <!--                        sm12-->
                    <!--                        md12>-->
                    <!--                      <base-checkbox-->
                    <!--                          v-model="editedItem.active"-->
                    <!--                      > Active </base-checkbox>-->
                    <!--                    </v-flex>-->
                  </v-layout>
                </v-container>

                <v-card-actions>
                  <base-button
                    @click="close">Cancel</base-button>

                  <v-spacer/>
                  <base-button
                    type="primary"
                    @click="save">Save</base-button>
                </v-card-actions>
              </card>
            </v-dialog>

            <v-data-table
              :headers="headers"
              :items="TagList"
              :pagination.sync="pagination"
              :total-items="totalTags"
              :loading="loading"
              :light="false"
              class="table table-striped"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="editItem(props.item)">

                  <td>{{ props.item.id }}</td>
                  <td>
                    {{ props.item.name }}
                  </td>

                  <td>
                    {{ props.item.slug }}
                  </td>
                  <td>
                    {{ props.item.count }}
                  </td>
                  <!--                  <td>-->
                  <!--                    {{ props.item.display_order }}-->
                  <!--                  </td>-->
                  <!--                  <td> <v-icon v-if="props.item.active">check</v-icon></td>-->

                  <td class="justify-center ">
                    <a
                      :href="webUrl + props.item.id + '/' + props.item.slug + '?tagName=' + props.item.name"
                      target="_blank"
                      title="Go to topics that has this tag">
                      &nbsp;
                      &nbsp;
                      <i class="tim-icons icon-link-72 pointer">
                        &nbsp;
                        &nbsp;
                      </i>
                    </a>
                  </td>
                  <td class="justify-center ">
                    <i
                      class="tim-icons icon-pencil pointer"
                      @click="editItem(props.item)"/>
                    &nbsp;&nbsp;
                    <i
                      class="tim-icons icon-trash-simple pointer"
                      @click="deleteItem(props.item)"/>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import BaseButton from '@/components/BaseButton'

export default {
  components: { BaseButton },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {
      rowsPerPage: 10,
      sortBy: 'id',
      descending: 'true'
    },
    TagList: [

    ],
    webUrl: '',
    totalTags: 0,
    loading: true,

    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    search: '',
    headers: [
      {
        text: 'Id',
        value: 'id'
      },
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Slug',
        value: 'slug'
      },
      {
        text: 'Count',
        value: 'count'
      },
      // {
      //   text: 'Display Order',
      //   align: 'left',
      //   value: 'display_order'
      // },
      // {
      //   text: 'Active',
      //   value: 'active',
      // },
      {
        text: 'Topics',
        value: 'Topics',
        sortable: false
      },
      {
        text: 'Action',
        value: 'Action',
        sortable: false
      }
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      name: '',
      slug: '',
      count: ''
    },
    defaultItem: {
      id: '',
      name: '',
      slug: '',
      count: ''
    }
  }),

  computed: {
    ...mapState('app', ['color']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Tag' : 'Edit Tag'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    pagination: {
      handler () {
        this.index()
      },
      deep: true
    }
  },
  created () {
    this.webUrl = location.protocol + '//' + this.$store.state.city.id + '.' + this.customerWebDomain + '/tags/'
  },

  methods: {
    index () {
      this.$store.state.spinning = true
      this.loading = true
      const params = new URLSearchParams(this.pagination)

      params.append('search', this.search)
      let self = this
      axios.get('/tags?' + params.toString())
        .then(response => {
          self.TagList = response.data.data
          self.totalTags = response.data.total
          self.$store.state.spinning = false
          self.loading = false
        })
        .catch(err => {
          if (err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(JSON.stringify(err.response.data.errors))
          }
          self.$store.state.spinning = false
          self.loading = false
          console.log(err.response.data.errors)
        })
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.TagList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    deleteItem (item) {
      const index = this.TagList.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        this.$store.state.spinning = true
        axios.delete('/tags/' + item.id)
          .then((response) => {
            this.TagList.splice(index, 1)
            this.deleteInline()
            this.close()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error.response && error.response.status == '403') {
              this.showError('Unauthorized')
            } else {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      // update
      if (this.editedIndex !== -1) {
        this.$store.state.spinning = true
        axios.put('/tags/' + this.editedItem.id, this.editedItem)
          .then((response) => {
            Object.assign(this.TagList[this.editedIndex], response.data)
            this.saveInline()
            this.close()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error.response && error.response.status == '422') {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
      // create
      else {
        this.$store.state.spinning = true
        axios.post('/tags', this.editedItem)
          .then((response) => {
            this.TagList.unshift(response.data)
            this.saveInline()
            this.close()
            this.$store.state.spinning = false
          })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Tag saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Tag deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
